import getFirebaseAuth from 'actions/firebase/auth'

const getCurrentUser = () => getFirebaseAuth().currentUser

export default getCurrentUser
